<!-- 网站地图 -->
<template>
  <transition name="el-fade-in-linear">
    <div id="Mzsm">
      <headerVue></headerVue>
      <div class="container">
        <div class="title">免责声明</div>
        <!-- 循环 -->
        <div class="content">
          <p>陕西九三学社网站版权与免责声明：</p>
          <p>① 凡本网注明“来源：陕西九三学社”的所有文字、图片和音视频稿件，版权均属陕西九三学社和陕西九三学社网站所有， 任何媒体、网站或个人如有需要链接转载或其它 方式调用者，请注明摘自“陕西九三学社网站”或相关字样。</p>
          <p>
            ②凡本网未注明“来源：陕西九三学社”的所有文字、图片和音视频等稿件均为转载稿，本网转载仅为提供更多信息和促进交流之目的，不代表同意其观点或证实其内容的真实性，不代表本站观点，仅供参考，我们不作任何承诺保证，不承担任何的责任。如其他媒体、网站或个人从本网下载使用，
            必须保留本网注明的"稿件来源"，并自负版权等法律责任。如擅自篡改为"来源：陕西九三学社"，本网将依法追究责任</p>
          <p> ③ 如因作品内容、版权和其它问题需要同本网联系的，请在30日内进行。※ 联系方式：宣传部 电话：029-63903372</p>
        </div>
      </div>
      <footerVue></footerVue>
    </div>
  </transition>
</template>

<script>
import headerVue from '../index/header.vue'
import footerVue from '../foot/foot.vue'
export default {
  name: 'Mzsm',
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  },
  components: {
    headerVue,
    footerVue
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  margin: auto;
  background-color: white;
  margin-top: 20px;

  .title {
    padding: 10px;
    padding-bottom: 20px;
    font-size: 20px;
    text-align: center;
    letter-spacing: 1px;
  }

  .content {
    text-indent: 2em;
    color: #4D4F53;
    line-height: 60px;
    padding: 10px;
  }
}
.transition-box {
    margin-bottom: 10px;
    width: 200px;
    height: 100px;
    border-radius: 4px;
    background-color: #409EFF;
    text-align: center;
    color: #fff;
    padding: 40px 20px;
    box-sizing: border-box;
    margin-right: 20px;
  }
</style>